import { useEffect } from "react";
import { motion } from "framer-motion";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

const sections = [
  {
    title: "1. Titolare del trattamento",
    paragraphs: [
      "EDILSTUDIO s.r.l. — Email: info@semplificaffitto.it",
      "Il Titolare è responsabile del trattamento dei dati personali raccolti tramite la piattaforma Semplificaffitto.it (\"la Piattaforma\").",
    ],
  },
  {
    title: "2. Dati raccolti",
    list: [
      "Dati anagrafici: nome, cognome, codice fiscale, data di nascita, residenza",
      "Dati di contatto: email, telefono",
      "Dati bancari: IBAN, dati fiscali (Partita IVA)",
      "Dati contrattuali: contratti di locazione, canoni, pagamenti",
      "Dati documentali: documenti caricati dall'amministratore (carta d'identità, fatture, ecc.)",
      "Dati tecnici di accesso: indirizzo IP, log di accesso, tentativi di login (per sicurezza)",
    ],
  },
  {
    title: "3. Finalità e base giuridica",
    list: [
      "Esecuzione del contratto (Art. 6.1.b GDPR): gestione affitti, pagamenti, fatturazione",
      "Obblighi di legge (Art. 6.1.c): adempimenti fiscali, registrazione contratti all'Agenzia delle Entrate, antiriciclaggio",
      "Legittimo interesse (Art. 6.1.f): sicurezza dei sistemi informatici, prevenzione frodi, audit trail",
      "Consenso (Art. 6.1.a GDPR): statistiche di misurazione con Google Analytics 4 e Meta Pixel, attivati solo dopo accettazione del banner cookie, e comunicazioni commerciali facoltative",
    ],
  },
  {
    title: "4. Conservazione dei dati",
    paragraphs: ["I dati personali vengono conservati per il tempo strettamente necessario:"],
    list: [
      "Documenti fiscali e contabili: 10 anni (art. 2220 c.c.)",
      "Contratti di locazione registrati: 10 anni dal termine",
      "Log di accesso/audit: 24 mesi",
      "Dati di profilo (utenti non attivi): fino a 12 mesi dalla cessazione, salvo richiesta di cancellazione",
    ],
  },
  {
    title: "5. I tuoi diritti (Artt. 15–22 GDPR)",
    paragraphs: ["In qualsiasi momento puoi esercitare i seguenti diritti:"],
    list: [
      "Accesso (Art. 15): conoscere quali dati abbiamo su di te",
      "Rettifica (Art. 16): correggere dati inesatti",
      "Cancellazione (Art. 17): chiedere la cancellazione dei tuoi dati (entro i limiti di legge)",
      "Limitazione (Art. 18): bloccare temporaneamente il trattamento",
      "Portabilità (Art. 20): ricevere i tuoi dati in formato strutturato",
      "Opposizione (Art. 21): opporti al trattamento per legittimo interesse",
    ],
    after: "Come esercitarli: scrivi a info@semplificaffitto.it specificando il diritto che intendi esercitare. Ti risponderemo entro 30 giorni. Nota: per i dati soggetti ad obbligo di conservazione decennale procederemo, dove possibile, con l'anonimizzazione mantenendo solo le informazioni necessarie agli adempimenti di legge.",
  },
  {
    title: "6. Cookie utilizzati",
    paragraphs: [
      "Il sito utilizza cookie tecnici essenziali e il salvataggio locale (localStorage) per il funzionamento del servizio (autenticazione, sessione utente, memorizzazione della tua scelta sui cookie), che non richiedono consenso (Art. 122 D.Lgs. 196/2003).",
      "Statistiche interne first-party: raccogliamo in forma anonima dati di navigazione (pagine visitate, tipo di dispositivo, permanenza) tramite un identificatore casuale non riconducibile alla tua identità, senza cookie di terze parti, sulla base del legittimo interesse a migliorare il servizio.",
      "Google Analytics 4 (Google Ireland Ltd): solo previo tuo consenso espresso tramite il banner cookie (Art. 6.1.a GDPR), utilizziamo GA4 per statistiche aggregate di utilizzo del sito. GA4 installa i cookie _ga e _ga_* (durata fino a 14 mesi) e anonimizza l'indirizzo IP. Senza il tuo consenso nessun cookie di misurazione viene installato e nessun dato viene inviato a Google.",
      "Meta Pixel (Meta Platforms Ireland Ltd): solo previo tuo consenso espresso tramite il banner cookie, utilizziamo il Pixel di Meta per misurare l'efficacia delle nostre campagne su Facebook e Instagram (eventi di visualizzazione pagina e di richiesta di contatto, senza trasmettere a Meta i contenuti dei moduli). Il Pixel installa i cookie _fbp e _fbc (durata fino a 3 mesi). Senza il tuo consenso il Pixel non viene caricato e nessun dato viene inviato a Meta.",
      "Revoca del consenso e opt-out: puoi revocare il consenso in qualsiasi momento cancellando cookie e dati del sito dalle impostazioni del tuo browser (al caricamento successivo il banner ti chiederà di nuovo la scelta), oppure installando il componente aggiuntivo di disattivazione di Google Analytics (tools.google.com/dlpage/gaoptout).",
    ],
  },
  {
    title: "7. Sicurezza dei dati",
    list: [
      "Connessione HTTPS obbligatoria (TLS 1.2+)",
      "Password salvate con hashing bcrypt",
      "Blocco degli accessi dopo ripetuti tentativi falliti",
      "Cookie di sessione protetti",
      "Mascheramento dei dati personali nei log di sistema",
      "Storage su Object Storage cifrato (datacenter Italia)",
    ],
  },
  {
    title: "8. Trasferimento dei dati",
    paragraphs: [
      "I dati sono ospitati esclusivamente su server localizzati nello Spazio Economico Europeo (Italia). Non avviene trasferimento di dati personali al di fuori dell'UE.",
    ],
  },
  {
    title: "9. Reclami",
    paragraphs: [
      "Se ritieni che il trattamento dei tuoi dati personali violi il GDPR, hai diritto di proporre reclamo al Garante per la Protezione dei Dati Personali: www.garanteprivacy.it",
      "Per qualsiasi domanda sulla privacy: info@semplificaffitto.it",
    ],
  },
];

export default function PrivacyPage() {
  useEffect(() => {
    const prev = document.title;
    document.title = "Privacy e Cookie — Semplificaffitto.it";
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    meta?.setAttribute("content", "Informativa privacy e cookie di Semplificaffitto.it ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003.");
    return () => {
      document.title = prev;
      if (meta && prevDesc) meta.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <main className="bg-paper min-h-screen" data-testid="privacy-page">
      <Nav />
      <article className="max-w-3xl mx-auto px-5 lg:px-8 pt-36 lg:pt-44 pb-24">
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="eyebrow text-brandblue mb-4">Documento legale</p>
          <h1 className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight mb-3" data-testid="privacy-title">
            Informativa Privacy
          </h1>
          <p className="text-sm text-ink/50 mb-12">
            Ai sensi del Regolamento UE 2016/679 (GDPR) e del D.Lgs. 196/2003 · Ultimo aggiornamento: 02/10/2026
          </p>

          <div className="space-y-10">
            {sections.map((s) => (
              <section key={s.title} data-testid={`privacy-section-${s.title.split(".")[0]}`}>
                <h2 className="font-serif font-semibold text-xl lg:text-2xl mb-4 text-ink">{s.title}</h2>
                {s.paragraphs?.map((p, i) => (
                  <p key={i} className="text-base text-ink/70 leading-relaxed mb-3">{p}</p>
                ))}
                {s.list && (
                  <ul className="space-y-2.5">
                    {s.list.map((item, i) => (
                      <li key={i} className="flex gap-3 text-base text-ink/70 leading-relaxed">
                        <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-azure shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
                {s.after && <p className="text-base text-ink/70 leading-relaxed mt-4">{s.after}</p>}
              </section>
            ))}
          </div>
        </motion.div>
      </article>
      <Footer />
    </main>
  );
}
